import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, viewport } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <ListingImageGallery
      className={css.productGallery}
      images={images}
      imageVariants={imageVariants}
      thumbnailVariants={thumbnailVariants}
      viewport={viewport}
      listingTitle={listing.attributes.title}
    />
  );
};

export default SectionGallery;
